import type { DailyCost } from '@cobliteam/common-types';
import { currencyFormatter, numberFormatter } from '@cobliteam/maintenance/src/components/utils';
import DataTable from '@cobliteam/ui-business/components/DataTable';
import { format } from '@cobliteam/utils/date';
import type { ColumnDef } from '@tanstack/react-table';

const columns: ColumnDef<DailyCost>[] = [
  {
    id: 'date',
    accessorKey: 'date',
    accessorFn: (row) => row.date,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={format(row.original.date, 'dd/MM/yyyy')} />,
    meta: {
      name: 'Data',
    },
  },
  {
    id: 'drivers',
    size: 200,
    accessorKey: 'drivers',
    accessorFn: (row) => row.drivers.join(', '),
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={row.original.drivers.join(', ') || 'Nenhum associado'} />,
    meta: {
      name: 'Motoristas',
    },
  },
  {
    id: 'drivenDistance',
    accessorKey: 'drivenDistance',
    accessorFn: (row) => `${(row.distanceDrivenInMeters / 1000).toFixed(1)} Km`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={`${numberFormatter.format(Number((row.original.distanceDrivenInMeters / 1000).toFixed(1)))} Km`} />,
    meta: {
      name: 'Kms Rodados',
    },
  },
  {
    id: 'fuelCost',
    accessorKey: 'fuelCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.fuelCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.fuelCost)} />,
    meta: {
      name: 'Combustível',
    },
  },
  {
    id: 'correctiveCost',
    accessorKey: 'fuelCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.preventiveMaintenanceCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.preventiveMaintenanceCost)} />,
    meta: {
      name: 'Man. Preventiva',
    },
  },
  {
    id: 'preventiveCost',
    accessorKey: 'fuelCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.correctiveMaintenanceCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.correctiveMaintenanceCost)} />,
    meta: {
      name: 'Man. Corretiva',
    },
  },
  {
    id: 'totalCost',
    accessorKey: 'totalCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.fuelCost + row.preventiveMaintenanceCost + row.correctiveMaintenanceCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => (
      <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.fuelCost + row.original.preventiveMaintenanceCost + row.original.correctiveMaintenanceCost)} />
    ),
    meta: {
      name: 'Gasto',
    },
  },
];

export default columns;
